import { render, staticRenderFns } from "./CongratModal.vue?vue&type=template&id=3549af5e&"
import script from "./CongratModal.vue?vue&type=script&lang=js&"
export * from "./CongratModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports